import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Constants} from '../shared/constants';
import {HeaderFilterOption, LoadOptions} from '../shared/models/shared.model';
import {Observable} from 'rxjs';
import {QuarterMasterGridEditingOption, QuarterMasterGridResultModel} from '../shared/models/quarter-master.model';
import {HeaderFilterData} from '../shared/models/product.model';

@Injectable({
  providedIn: 'root'
})
export class QuarterMasterService {

  private token = localStorage.getItem('token');
  private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

  private url = Constants.devServerEndpoint + 'api/quartermastergrid';

  constructor(private httpClient: HttpClient) { }

  public getQuarterMasterGrid(param: LoadOptions): Observable<QuarterMasterGridResultModel> {
	return this.httpClient
		.post<QuarterMasterGridResultModel>(
		this.url + `/getQuarterMasterGrid/`, param,
		{ headers: this.headers }
		);
  }

  public getHeaderFiltersQuarterMasterGrid(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
	return this.httpClient
		.post<HeaderFilterData[]>(
		this.url + `/getHeaderFiltersQuarterMasterGrid`, param,
		{ headers: this.headers }
		);
  }

  public mappingAction(param): Observable<any> {
	return this.httpClient
		.post<any>(
		this.url + '/mappingAction', param,
		{ headers: this.headers }
		);
  }

  public addNewQuarterMaster(CreatedByUserId: number): Observable<any> {
	return this.httpClient
		.post<any>(
		this.url + '/addNewQuarterMaster', {CreatedByUserId},
		{ headers: this.headers }
		);
  }

  public editingAction(editingData: QuarterMasterGridEditingOption): Observable<any> {
	return this.httpClient
		.post<any>(
		this.url + '/editingAction', editingData,
		{ headers: this.headers }
		);
  }
}
